<!-- Toast card -->
<div
  class="relative flex overflow-hidden rounded-xl bg-white shadow-lg border border-slate-100 border-l-4 w-[360px]"
  [ngClass]="colors.border">

  <!-- Progress bar (shrinks left→right) -->
  @if ((toast.duration ?? 12000) > 0) {
    <div
      class="absolute bottom-0 left-0 h-0.5 transition-none"
      [ngClass]="colors.bar"
      [style.width.%]="progress()">
    </div>
  }

  <!-- Left: icon square + text content -->
  <div class="flex items-center gap-3 flex-1 min-w-0 p-4">

    <!-- Icon — filled square with rounded corners -->
    <div
      class="flex flex-shrink-0 items-center justify-center w-10 h-10 rounded-lg"
      [ngClass]="colors.iconBg">
      <mat-icon
        class="icon-size-5 text-white"
        [svgIcon]="toast.icon ?? 'heroicons_outline:bell-alert'">
      </mat-icon>
    </div>

    <!-- Text block -->
    <div class="flex flex-col min-w-0">
      @if (toast.label) {
        <p class="text-[10px] font-semibold uppercase tracking-wide mb-0.5" [ngClass]="colors.labelColor">{{ toast.label }}</p>
      }
      <p class="text-sm font-bold text-slate-800 leading-tight truncate">{{ toast.title }}</p>
      @if (toast.subtitle) {
        <p class="text-xs text-slate-500 mt-0.5 leading-snug">{{ toast.subtitle }}</p>
      }
      @if (toast.time) {
        <p class="text-xs text-slate-400 mt-0.5">{{ toast.time }}</p>
      }
    </div>

  </div>

  <!-- Right: actions panel — full height, vertical divider, each action separated by horizontal line -->
  @if (toast.actions?.length) {
    <div class="flex flex-shrink-0 flex-col border-l border-slate-100">
      @for (action of toast.actions; track action.label; let last = $last) {
        <button
          (click)="onAction(action.onClick)"
          class="flex flex-1 items-center justify-center px-5 text-xs font-semibold transition-colors whitespace-nowrap"
          [ngClass]="actionClass(action)">
          {{ action.label }}
        </button>
        @if (!last) {
          <div class="border-t border-slate-100"></div>
        }
      }
    </div>
  } @else {
    <!-- No actions: small dismiss button -->
    <button
      (click)="dismiss()"
      class="flex-shrink-0 flex items-center self-start p-2 mt-2 text-slate-300 hover:text-slate-500 transition-colors">
      <mat-icon class="icon-size-4" svgIcon="heroicons_outline:x-mark"></mat-icon>
    </button>
  }

</div>
